import { OffersApiClient } from '@fourthwall/services/dist/OffersApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useUpdateOfferSlugMutation = createMutationHook(OffersApiClient.updateOfferSlug, {
  mutationKey: ['updateOfferSlug'],
})
